export const getFilterMode = (STP, LTP) => {
    if (STP === undefined || LTP === undefined) return null;

    const isStpOnly = STP && !LTP;

    return {
        isStpMode: isStpOnly,
        isLtpMode: !isStpOnly,
    };
};
